import React, { useEffect } from 'react'
import BarcodeScannerComponent from "react-webcam-barcode-scanner"

// function BarcodeScan({ onDetectCode }) {
//   const [ data, setData ] = React.useState('')

//   return (
//     <div>
//       <BarcodeScannerComponent
//         width={'100%'}
//         height={'100%'}
//         onUpdate={(err, result) => {
//           if (result) {
//             setData('Buscando...')
//             onDetectCode(result.text)
//           }
//           else setData('No se reconoce el código')
//         }}
//       />
//       <div style={{textAlign:'center', color:'#FF6868', fontWeight:'bold'}}>{data}</div>
//     </div>
//   )
// }
 
// export default BarcodeScan


class BarcodeScan extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      results: []
    }
  }

  onDetected = (result) => {
    console.log(result)
    this.setState({
      results: [...this.state.results, result]
    })
    if (this.detectBarcode(result)) {
      this.setState({ results: [] })
      this.props.onDetectCode(result)
    }
    else this.setState({ results: ['No se reconoce el código']})
  }

  detectBarcode = (result) => {
    console.log(result)
    // const totalResults = this.state.results.filter(r => r === result)
    // return totalResults.length > 1 ? true : false
    return true
  }

  render() {
    return (
      <>
        <BarcodeScannerComponent
          width={'100%'}
          height={'100%'}
          onUpdate={(err, result) => {
            if (result) this.onDetected(result.text)
          }}
        />
        <div style={{textAlign:'center', color:'#FF6868', fontWeight:'bold'}}>{this.state.results[0]}</div>
      </>
    )
  }
}

export default BarcodeScan


